
import Fuse from "fuse.js";

export default {
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    dummySearch: {
      type: Boolean,
      default: false,
    },
    propsToSearch: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },

  data () {
    return {
      fuseSearch: null,
      searchQuery: ''
    }
  },

  mounted () {
    this.fuseSearch = new Fuse(this.tableData, {
      keys: this.propsToSearch,
      threshold: 0.3
    })
  },

  methods: {
    search(value) {
      const fuseSearch = this.fuseSearch
      if (!value) {
        value = this.searchQuery
      }

      if (value !== "" && fuseSearch) {
        return fuseSearch.search(value)
      } else {
        return this.tableData
      }
    }

  },

  computed: {
    searchedData() {
      const { fuseSearch, tableData, dummySearch, propsToSearch } = this
      const hasProps = !!propsToSearch.length
      const value = this.searchQuery
      if (hasProps && !dummySearch && value && value !== "" && fuseSearch) {
        return fuseSearch.search(value)
      } else {
        return this.tableData
      }
    }
  },

  watch: {
    searchedData(value) {
      this.$emit('input', value)
    },
    tableData(value) {
      this.fuseSearch.list = value
    },
    propsToSearch(value=[]) {
      this.fuseSearch.keys = value
    },
    searchQuery(value) {
      this.$emit('updatedSearchQuery', value)
      this.$emit('update:searchString', value)
    }
  },
}


// WEBPACK FOOTER //
// ./src/components/Tables/search.js